/*
* HTML-valid and support all Vue directives using only data-v-* attributes.
* We'll handle:
data-v-click → @click
data-v-bind-xxx → :xxx
data-v-model → v-model
data-v-if, data-v-else-if, data-v-else → v-if, v-else-if, v-else
data-v-for → v-for
data-v-show → v-show
data-v-text → {{ }}
data-v-html → v-html
data-v-key → :key
*
* */
export function convertDataVToVue(root) {
	let template = root.innerHTML;
	

// --- Event listeners: data-v-click, data-v-mouseover, etc. with modifiers
	template = template.replace(
		/data-v-([a-zA-Z]+)((?:\.[a-zA-Z]+)*)="(.+?)"/g,
		(_, event, modifiers, value) => {
			// Skip known special directives handled later
			const skip = ['model', 'if', 'else-if', 'else', 'for', 'show', 'text', 'html', 'key'];
			if (skip.includes(event)) return `data-v-${event}${modifiers}="${value}"`;
			
			// modifiers: e.g. ".stop.prevent" → keep as is
			return `@${event}${modifiers}="${value}"`;
		}
	);
	
	// --- v-bind: data-v-bind-xxx → :xxx
	template = template.replace(/data-v-bind-([a-zA-Z0-9_-]+)="(.+?)"/g, ':$1="$2"');
	
	// --- v-model
	template = template.replace(/data-v-model="(.+?)"/g, 'v-model="$1"');
	
	// --- v-if / v-else-if / v-else
	template = template.replace(/data-v-if="(.+?)"/g, 'v-if="$1"');
	template = template.replace(/data-v-else-if="(.+?)"/g, 'v-else-if="$1"');
	template = template.replace(/data-v-else/g, 'v-else');
	
	// --- v-show
	template = template.replace(/data-v-show="(.+?)"/g, 'v-show="$1"');
	
	// --- v-for
	template = template.replace(/data-v-for="(.+?)"/g, 'v-for="$1"');
	
	// --- key
	template = template.replace(/data-v-key="(.+?)"/g, ':key="$1"');
	
	// --- v-text → {{ }}
	template = template.replace(
		/data-v-text="(.+?)"/g,
		'v-text="$1"'
	);
	// Remove any inner content from v-text elements
	template = template.replace(
		/(<(\w+)[^>]*v-text=".+?"[^>]*>)([\s\S]*?)(<\/\2>)/g,
		'$1$4'
	);
	
	// --- v-html
	template = template.replace(/data-v-html="(.+?)"/g, 'v-html="$1"');
	
	// Update root
	return template;
}
